import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'suggested-for-you',
  templateUrl: './suggested-for-you.html',
  standalone: false,
})
export class SuggestedForYouComponent implements OnInit {
    @Input('productsInCart') productsInCart:any;
    @Input('cartDiscount') cartDiscount:number;
    @Input('totalSp') totalSp:number;
    @Input('recommendedItems') recommendedItems: any;
    @Output('goToCart') goToCart:EventEmitter<void> = new EventEmitter();

  constructor(
    private readonly eventLogger: EventLoggerService,
  ) {
  }
    ngOnInit(): void { }
    handleClick():void {
      this.goToCart.emit(this.recommendedItems[0]);
      this.eventLogger.cleverTapEvent('Buy_Now_Cart_banner_HP_clicked', JSON.stringify({ type: 'suggested_for_you' }));
    }
}
